/**
 * Shared ScrollTrigger setup (same behavior as index.html).
 * Load order: gsap.min.js → ScrollTrigger.min.js → this file → page inline scripts.
 *
 * normalizeScroll: all pages that include this file get mobile/tablet touch scroll
 * stabilisation for pin/scrub (iOS rubber-band). No per-page duplicate needed.
 */
(function () {
  if (typeof window.gsap === "undefined" || typeof window.ScrollTrigger === "undefined") {
    return;
  }

  var gsap = window.gsap;
  var ScrollTrigger = window.ScrollTrigger;

  gsap.registerPlugin(ScrollTrigger);

  /** Mobile/tablet: stabilise pin/scrub touch scroll (iOS rubber-band). Safe to call again after Lenis init. */
  window.onoureApplyNormalizeScroll = function () {
    if (!ScrollTrigger.normalizeScroll) return;
    if (window.matchMedia("(max-width: 992px)").matches) {
      ScrollTrigger.normalizeScroll({ allowNestedScroll: true });
    }
  };

  (function initNormalizeScrollMobile() {
    var mm = gsap.matchMedia();
    mm.add("(max-width: 992px)", function () {
      // allowNestedScroll: nested overflow:auto/scroll (e.g. .filter-section horizontal strip) keeps native scroll
      window.onoureApplyNormalizeScroll();
      return function () {
        ScrollTrigger.normalizeScroll(false);
        ScrollTrigger.refresh();
      };
    });
  })();

  // Real mobile devices: URL bar show/hide changes layout height. Default ignoreMobileResize
  // skips ScrollTrigger.refresh() and pin/scrub math stays stale — scroll-up then looks broken.
  ScrollTrigger.config({ ignoreMobileResize: false });

  (function initScrollTriggerMobileViewportSync() {
    var debounceTimer;
    var lastVh = window.visualViewport ? window.visualViewport.height : 0;
    function scheduleViewportRefresh(force) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (!force && window.visualViewport) {
          var h = window.visualViewport.height;
          if (lastVh > 0 && Math.abs(h - lastVh) < 48) {
            return;
          }
          lastVh = h;
        }
        ScrollTrigger.refresh();
      }, 200);
    }
    if (window.visualViewport) {
      lastVh = window.visualViewport.height;
      window.visualViewport.addEventListener(
        "resize",
        function () {
          scheduleViewportRefresh(false);
        },
        { passive: true }
      );
    }
    window.addEventListener("orientationchange", function () {
      lastVh = 0;
      scheduleViewportRefresh(true);
    });
  })();

  // Page load + resize par ScrollTrigger refresh
  setTimeout(function () {
    ScrollTrigger.refresh();
  }, 500);
  window.addEventListener("load", function () {
    ScrollTrigger.refresh();
  });
  window.addEventListener("resize", function () {
    ScrollTrigger.refresh();
  });
})();